import React from 'react';
import { Route, Switch } from 'react-router-dom';
import OrganisationsErrorPage from '../components/OrganisationsErrorPage';
import Organisations from '../components/Organisations';
import CreateOrganisation from '../containers/CreateOrganisation';
import EditOrganisation from '../containers/EditOrganisation';
import OrganisationDetails from '../components/OrganisationDetails';
import { TABS, PRINCIPAL_ACTIONS } from '../constants';
import PrincipalDetail from '../components/principals/PrincipalDetail';

const OrganisationsScene = () => (
  <Switch>
    <Route path="/organisations" component={Organisations} exact menuName="Organisations" />
    <Route
      path="/organisations/error"
      component={OrganisationsErrorPage}
      exact
      menuName="Organisations"
    />
    <Route
      path="/organisations/new"
      component={CreateOrganisation}
      exact
      menuName="Organisations"
    />
    <Route
      path="/organisations/:id/edit"
      component={EditOrganisation}
      exact
      menuName="Organisations"
    />
    <Route
      path={`/organisations/:id/${TABS.PRINCIPALS}/${PRINCIPAL_ACTIONS.DETAILS}/:actionId/:tab?`}
      component={PrincipalDetail}
      exact
      menuName="Organisations"
    />
    <Route
      path="/organisations/:id/:tab?/:action?/:actionId?"
      component={OrganisationDetails}
      exact
      menuName="Organisations"
    />
  </Switch>
);

export default OrganisationsScene;
